"use client";

import { useTranslations } from "next-intl";
import { useEffect, useState } from "react";

export function ThemeToggle() {
  const t = useTranslations("ThemeToggle");
  const [isDark, setIsDark] = useState(() => {
    if (typeof window === "undefined") {
      return false;
    }
    const stored = window.localStorage.getItem("app-buddy-theme");
    if (stored) {
      return stored === "dark";
    }
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  });

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle("dark", isDark);
    window.localStorage.setItem("app-buddy-theme", isDark ? "dark" : "light");
  }, [isDark]);

  return (
    <div
      className="inline-flex items-center gap-1 rounded-full border border-zinc-300 bg-zinc-100/90 p-1 dark:border-zinc-700 dark:bg-zinc-900/80"
      role="group"
      aria-label={t("aria")}
    >
      <button
        type="button"
        onClick={() => setIsDark(false)}
        aria-pressed={!isDark}
        className={`rounded-full px-2 py-0.5 text-xs transition ${
          !isDark ? "bg-zinc-200 text-zinc-900 dark:bg-zinc-700 dark:text-zinc-100" : "text-zinc-600 hover:text-zinc-800 dark:text-zinc-400 dark:hover:text-zinc-200"
        }`}
      >
        {t("light")}
      </button>
      <button
        type="button"
        onClick={() => setIsDark(true)}
        aria-pressed={isDark}
        className={`rounded-full px-2 py-0.5 text-xs transition ${
          isDark ? "bg-zinc-200 text-zinc-900 dark:bg-zinc-700 dark:text-zinc-100" : "text-zinc-600 hover:text-zinc-800 dark:text-zinc-400 dark:hover:text-zinc-200"
        }`}
      >
        {t("dark")}
      </button>
    </div>
  );
}
